import React, { useEffect, useRef, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Spinner } from '@blueprintjs/core';
import CommonGrid from 'shared/commonGrid';
import { ROWSELECTION } from 'shared/commonGrid/grid-enums';
import { MenuActions } from './MenuActions';
import useFqdn from '../../hooks/useFqdn'
import { fqdnColumnDefs, fqdnGroupColumnDef } from '../../fqdn.types'

export const FqdnList:FC = () => {
  const { t } = useTranslation()
  const { onEnterFqdnlist, isLoading, ...fqdn } = useFqdn()

  const enterFqdnList = useRef(() => onEnterFqdnlist())

  useEffect(() => {
    enterFqdnList.current()
  }, [])

  return (
    <React.Fragment>
      {isLoading && <Spinner aria-label="Loading..." />}
      {!isLoading && (
        <div data-testid="FqdnList" className="GridPageContainer">
          <CommonGrid
            pagination
            enableBrowserTooltips
            noResults={false}
            createNewText={t('fqdn.grid.newFqdn')}
            rowSelection={ROWSELECTION.SINGLE}
            rowMultiSelectWithClick={false}
            autoGroupColumnDef={fqdnGroupColumnDef}
            hasPrivilegeToCreateNew={fqdn.privileges.create}
            hasPrivilegeToDelete={fqdn.privileges.delete}
            hasPrivilegetoView={fqdn.privileges.view}
            rowData={fqdn.items}
            isBeforeLogout={false}
            columnDefs={fqdnColumnDefs}
            onRefresh={fqdn.onRefresh}
            handleCreateNew={fqdn.goToCreateFqdnPage}
            onSelectionChanged={fqdn.onSelectionChanged}
            onActionMenuItemClick={fqdn.goToViewSelectedFqdnPage}
            lastUpdatedAt={fqdn.lastUpdatedAt}
          >
            <MenuActions />
          </CommonGrid>
        </div>
      )}
    </React.Fragment>
  )
}

export default FqdnList
